import { useEffect, useState } from 'react';
import { accountDevicesQuery, subscribe } from '@/lib/firestore';
import type { DeviceMirror } from '@/schemas';

export type DeviceWithId = DeviceMirror & { id: string };

export function useDevices(aid: string | null): {
  devices: DeviceWithId[];
  loading: boolean;
} {
  // Derived loading: see useMyMemberships for the why.
  const [state, setState] = useState<{ loadedAid: string | null; data: DeviceWithId[] }>({
    loadedAid: null,
    data: [],
  });
  useEffect(() => {
    if (!aid) {
      setState({ loadedAid: null, data: [] });
      return;
    }
    setState({ loadedAid: null, data: [] });
    const unsub = subscribe<DeviceMirror>(accountDevicesQuery(aid), (rows) => {
      setState({ loadedAid: aid, data: rows });
    });
    return unsub;
  }, [aid]);
  return {
    devices: state.loadedAid === aid ? state.data : [],
    loading: aid != null && state.loadedAid !== aid,
  };
}
